"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.readFile = exports.createFormStateUpdaterFromEvent = exports.isToggleable = exports.isDescendant = exports.getInputElement = void 0;
const object_path_1 = __importDefault(require("object-path"));
function getInputElement(e) {
    return e.target instanceof HTMLInputElement
        ? e.target
        : e.target.querySelector('input');
}
exports.getInputElement = getInputElement;
function isDescendant(parentClassName, child) {
    var _a;
    let node = child.parentNode;
    while (node != null) {
        if ((_a = node.className) === null || _a === void 0 ? void 0 : _a.includes(parentClassName)) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}
exports.isDescendant = isDescendant;
function isToggleable(e) {
    const input = getInputElement(e);
    // in a dropdown? this is a select option
    if (isDescendant('j-select-dropdown', e.target)) {
        return false;
    }
    return ((input === null || input === void 0 ? void 0 : input.type) === 'checkbox' || (input === null || input === void 0 ? void 0 : input.type) === 'radio');
}
exports.isToggleable = isToggleable;
function createFormStateUpdaterFromEvent(props, e, prevFormData) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function* () {
        const { uncheckedValue = false, max, checkedValue = true, multiple, beforeFormChange, value } = props;
        const { value: inputValue, name } = e.target;
        const formValue = object_path_1.default.get(prevFormData, name);
        if (!name || name === '') {
            console.error('Bad onChange event with no "name" provided on target.');
        }
        let newFormValue = inputValue;
        const isInputToggleable = isToggleable(e);
        // if you provide value a boolean to a input, the event will come back in string form.
        if (isInputToggleable) {
            newFormValue = e.target.checked ? uncheckedValue : checkedValue;
            /* We dont want radios to be unclickable */
            if (e.target.type === 'radio') {
                newFormValue = (checkedValue !== null && checkedValue !== void 0 ? checkedValue : value);
            }
            if (newFormValue === 'false') {
                newFormValue = false;
            }
            if (newFormValue === 'true') {
                newFormValue = true;
            }
        }
        if (inputValue === undefined && !isInputToggleable) {
            console.error('<Form> onChange failed because a "value" is missing from input.', e.target);
            return;
        }
        if (Array.isArray(formValue)) {
            newFormValue = formValue.includes(inputValue)
                ? formValue.filter((v) => v !== inputValue)
                : formValue.concat([inputValue]);
            if (max === 1) {
                newFormValue = [inputValue];
            }
            else if (max !== undefined && max >= 0 && newFormValue.length > max) {
                newFormValue = newFormValue.slice(1, 999);
            }
        }
        /* dates will set undefined / null values to '' when encoding */
        if ((e.target.type === 'date' || e.target.type === 'datetime-local' || e.target.type === 'datetime') && newFormValue === '') {
            newFormValue = undefined;
        }
        if (newFormValue === 'null') {
            newFormValue = null;
        }
        if (e.target.type === 'number' && typeof newFormValue === 'string') {
            const isPriceInput = (_b = (_a = e.target.parentNode) === null || _a === void 0 ? void 0 : _a.className) === null || _b === void 0 ? void 0 : _b.includes('j-price-input');
            /* Pennies */
            newFormValue = isPriceInput
                ? (newFormValue * 100) : parseInt(newFormValue, 10);
        }
        if (e.target.type === 'file') {
            newFormValue = multiple ? e.target.files : (_c = e.target.files[0]) !== null && _c !== void 0 ? _c : '';
        }
        if (e.target.type === 'datetime-local' && newFormValue) {
            /* Convert the date to UTC, DO NOT REMOVE the Zulu as its needed for DateTime Local. */
            newFormValue = new Date(newFormValue).toISOString();
        }
        let newForm = Object.assign({}, prevFormData);
        object_path_1.default.set(newForm, e.target.name, newFormValue);
        if (beforeFormChange) {
            newForm = yield beforeFormChange(e, prevFormData);
        }
        return newForm;
    });
}
exports.createFormStateUpdaterFromEvent = createFormStateUpdaterFromEvent;
function readFile(file, onRead) {
    const fr = new FileReader();
    fr.readAsDataURL(file);
    fr.addEventListener('load', (e) => {
        if (fr.result) {
            onRead(fr.result, file.name);
        }
    });
    return fr;
}
exports.readFile = readFile;
